module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "forward"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/0001a.jpg"
    }
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("“The modern corporation as an institution is entitled to much more respect than it has frequently received. The dangers inherent in its use are also great enough to require serious attention. The possibilities of its continued development are, so far as one can see, unlimited. It is, in fact, an institution at a cross road in history, capable of becoming one of the master tools of society—capable also of surprising abuse; worthy of the attention of the community as well as of scholars.”")])]), _vm._v(" "), _c('div', {
    staticClass: "cite"
  }, [_c('p', [_c('span', [_vm._v("—Adolph Berle, Jr., "), _c('i', [_vm._v("The Twentieth Century Capitalist Revolution")])])])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("“Corporations just naturally grab all the power they can.”")])]), _vm._v(" "), _c('div', {
    staticClass: "cite"
  }, [_c('p', [_c('span', [_vm._v("—Juliette Beck")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-327ea164","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epub_9781605097121_2.vue
// module id = 72
// module chunks = 0